import { inject, Injectable } from '@angular/core';
import { EventType, NavigationEnd, Router } from '@angular/router';
import { filter, map, Observable } from 'rxjs';

import { PrimaryNavigationService, PrivaNavigationItem } from '@priva/appshell';

import { environment } from 'environments/environment';

import { absoluteRoutePaths } from './route-paths';

const defaultNavigation: PrivaNavigationItem[] = [
    {
        label: 'MENU.HOME',
        label_short: 'MENU.HOME',
        slug: 'home',
        url: '/',
        icon: 'far fa-sign-in',
    },
    {
        label: 'MENU.CROP_MAINTENANCE',
        label_short: 'MENU.CROP_MAINTENANCE_SHORT',
        slug: 'crop maintenance',
        url: absoluteRoutePaths.crop,
        icon: 'far fa-hand-holding-seedling',
    },
    {
        label: 'MENU.HARVEST',
        label_short: 'MENU.HARVEST',
        slug: 'harvest',
        url: absoluteRoutePaths.harvest,
        icon: 'far fa-boxes',
    },
    {
        label: 'MENU.PACKING',
        label_short: 'MENU.PACKING',
        slug: 'packing',
        url: absoluteRoutePaths.resultMeasurement,
        icon: 'far fa-boxes-packing',
    },
    {
        label: 'MENU.GENERAL',
        label_short: 'MENU.GENERAL',
        slug: 'general',
        url: absoluteRoutePaths.generic,
        icon: 'far fa-tasks',
    },
];

// When absoluteRoutePaths are added to this list, primary navigation will be hidden on these routes.
const pathsWithNoNavigation = [
    absoluteRoutePaths.scanFlow,
    absoluteRoutePaths.setup,
    absoluteRoutePaths.signin,
    absoluteRoutePaths.settings,
];

@Injectable({
    providedIn: 'root',
})
export class AppPrimaryNavigationService implements PrimaryNavigationService {
    private router = inject(Router);

    get navigation(): Observable<PrivaNavigationItem[]> {
        return this.router.events.pipe(
            filter(
                (e): e is NavigationEnd => e instanceof NavigationEnd && e.type === EventType.NavigationEnd,
            ),
            map((e) => (pathsWithNoNavigation.includes(e.url) ? [] : defaultNavigation)),
        );
    }

    constructor() {
        if (!environment.production) {
            defaultNavigation.push({
                label: 'MENU.DEVELOPER_TOOLS',
                label_short: 'MENU.DEVELOPER_TOOLS_SHORT',
                slug: 'developer',
                url: '/dev',
                icon: 'far fa-code',
            });
        }
    }

    getNavigation(): PrivaNavigationItem | undefined {
        const url = this.router.url;
        return defaultNavigation.find((navigation) => navigation.url === url);
    }

    getPageIcon(): string {
        const routerUrl = this.router.url;
        return defaultNavigation.find(({ url }) => url === routerUrl)?.icon ?? 'fa-question';
    }
}
